import { render } from "./TableView_Columns.vue?vue&type=template&id=54e5c694&scoped=true"
import script from "./TableView_Columns.vue?vue&type=script&lang=js"
export * from "./TableView_Columns.vue?vue&type=script&lang=js"

import "./TableView_Columns.vue?vue&type=style&index=0&id=54e5c694&scoped=true&lang=css"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e5c694"]])

export default __exports__